import { Injectable } from '@angular/core';
import { ComprasKpisPeriodoModel, DetalheAtributoModel } from '@app/data';
import { ApiService } from '@app/gateway';
import type { DashPeriodQueryPayload } from '@app/pages/dashboard/shared';

export type CompraDetalheDimension = 'grupo' | 'subgrupo' | 'secao' | 'marca' | 'fabricante';

@Injectable({ providedIn: 'root' })
export class ComprasService {
  constructor(protected readonly apiService: ApiService) {}

  public async kpisPeriodo(data: DashPeriodQueryPayload): Promise<ComprasKpisPeriodoModel[]> {
    try {
      const path: string = `compras/kpisPeriodo`;
      const result: ComprasKpisPeriodoModel[] = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load purchase KPIs.';
      throw new Error(message, { cause: e });
    }
  }

  public async detalheCompra(dimension: CompraDetalheDimension, data: DashPeriodQueryPayload): Promise<DetalheAtributoModel[]> {
    try {
      const path: string = `compras/detalheCompra`;
      const result: DetalheAtributoModel[] = await this.apiService.post({ path, data: { ...data, dimension } });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load purchase detail.';
      throw new Error(message, { cause: e });
    }
  }
}
